import type { UpdateResolver } from '@urql/exchange-graphcache'
import type {
    UpdateAnalyticsWidgetsMutation,
    UpdateAnalyticsWidgetsMutationVariables,
    UpdateHomePageWidgetsMutation,
    UpdateHomePageWidgetsMutationVariables,
    UpdateIAdamPreferencesMutation,
    UpdateMeetplaceBrandingSettingsMutation,
    UpdateMeetplaceBrandingSettingsMutationVariables,
    UpdateMeetplaceGroupsMembersPermissionsMutation,
    UpdateMeetplaceGroupsMembersPermissionsMutationVariables,
} from '@/generated/gql/graphql'
import { GET_USER_DATA } from '../utils/users'

export const userMutationUpdaters: Record<string, UpdateResolver> = {
    updateHomePageWidgets: (
        _parent: UpdateHomePageWidgetsMutation,
        args: UpdateHomePageWidgetsMutationVariables,
        cache,
    ) => {
        const {
            input: { homePageWidgets },
        } = args
        cache.updateQuery({ query: GET_USER_DATA }, (data) => {
            if (data != null) {
                return {
                    ...data,
                    me: {
                        ...data.me,
                        homePageWidgets,
                    },
                }
            }
            return null
        })
    },
    updateiAdamPreferences: (
        parent: UpdateIAdamPreferencesMutation,
        _args,
        cache,
    ) => {
        const { defaultLanguage, joinPreference } =
            parent.updateiAdamPreferences
        cache.updateQuery({ query: GET_USER_DATA }, (data) => {
            if (data == null) return null
            return {
                ...data,
                me: {
                    ...data.me,
                    iadamPreferences: {
                        ...data.me.iadamPreferences,
                        defaultLanguage,
                        joinPreference,
                    },
                },
            }
        })
    },
    updateAnalyticsWidgets: (
        _parent: UpdateAnalyticsWidgetsMutation,
        args: UpdateAnalyticsWidgetsMutationVariables,
        cache,
    ) => {
        const {
            input: { analyticsWidgets },
        } = args
        cache.updateQuery({ query: GET_USER_DATA }, (data) => {
            if (data != null) {
                return {
                    ...data,
                    me: {
                        ...data.me,
                        analyticPageWidgets: analyticsWidgets.map((widget) => ({
                            __typename: 'AnalyticsWidget' as const,
                            ...widget,
                        })),
                    },
                }
            }
            return null
        })
    },
    updateMeetplaceGroupsMembersPermissions: (
        _parent: UpdateMeetplaceGroupsMembersPermissionsMutation,
        args: UpdateMeetplaceGroupsMembersPermissionsMutationVariables,
        cache,
    ) => {
        const {
            input: { enableMeetplaceGroupsMembersEditPermission },
        } = args
        cache.updateQuery({ query: GET_USER_DATA }, (data) => {
            if (data != null) {
                return {
                    ...data,
                    me: {
                        ...data.me,
                        meetplace: {
                            ...data.me.meetplace,
                            groupMembersEditPermissions:
                                enableMeetplaceGroupsMembersEditPermission,
                        },
                    },
                }
            }
            return null
        })
    },
    updateMeetplaceBrandingSettings: (
        _parent: UpdateMeetplaceBrandingSettingsMutation,
        args: UpdateMeetplaceBrandingSettingsMutationVariables,
        cache,
    ) => {
        const {
            input: { fullLogoUrl, logoUrl, favIconUrl, verticalFullLogoUrl },
        } = args
        cache.updateQuery({ query: GET_USER_DATA }, (data) => {
            if (data != null) {
                return {
                    ...data,
                    me: {
                        ...data.me,
                        meetplace: {
                            ...data.me.meetplace,
                            fullLogoUrl:
                                fullLogoUrl ?? data.me.meetplace.fullLogoUrl,
                            logoUrl: logoUrl ?? data.me.meetplace.logoUrl,
                            favIconUrl:
                                favIconUrl ?? data.me.meetplace.favIconUrl,
                            verticalFullLogoUrl:
                                verticalFullLogoUrl ??
                                data.me.meetplace.verticalFullLogoUrl,
                        },
                    },
                }
            }
            return null
        })
    },
}
